"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/admin_common.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventRoleWithUserName = exports.EventRole = exports.TicketBonusMedia = exports.EventBonusMedia = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.event.v1.EventBonusMedia
 */
class EventBonusMedia extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * アップロードされたファイルのID
         *
         * @generated from field: string media_id = 1;
         */
        this.mediaId = "";
        /**
         * アップロードされたファイルの名前
         *
         * @generated from field: string filename = 2;
         */
        this.filename = "";
        /**
         * 特典名
         *
         * @generated from field: string bonus_name = 3;
         */
        this.bonusName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EventBonusMedia().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventBonusMedia().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventBonusMedia().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EventBonusMedia, a, b);
    }
}
exports.EventBonusMedia = EventBonusMedia;
EventBonusMedia.runtime = protobuf_1.proto3;
EventBonusMedia.typeName = "spwn.event.v1.EventBonusMedia";
EventBonusMedia.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "bonus_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "url_for_download", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.event.v1.TicketBonusMedia
 */
class TicketBonusMedia extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TicketBonusMedia().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TicketBonusMedia().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TicketBonusMedia().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(TicketBonusMedia, a, b);
    }
}
exports.TicketBonusMedia = TicketBonusMedia;
TicketBonusMedia.runtime = protobuf_1.proto3;
TicketBonusMedia.typeName = "spwn.event.v1.TicketBonusMedia";
TicketBonusMedia.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_info", kind: "message", T: EventBonusMedia },
    { no: 2, name: "release_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "expired_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * @generated from message spwn.event.v1.EventRole
 */
class EventRole extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID (firestoreのドキュメントID)
         *
         * @generated from field: string event_firestore_id = 1;
         */
        this.eventFirestoreId = "";
        /**
         * ユーザーID (firestoreのドキュメントID)
         *
         * @generated from field: string user_firestore_id = 2;
         */
        this.userFirestoreId = "";
        /**
         * ロール名
         *
         * @generated from field: repeated string role = 3;
         */
        this.role = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EventRole().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventRole().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventRole().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EventRole, a, b);
    }
}
exports.EventRole = EventRole;
EventRole.runtime = protobuf_1.proto3;
EventRole.typeName = "spwn.event.v1.EventRole";
EventRole.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.EventRoleWithUserName
 */
class EventRoleWithUserName extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ユーザー名
         *
         * @generated from field: string user_name = 2;
         */
        this.userName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EventRoleWithUserName().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventRoleWithUserName().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventRoleWithUserName().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EventRoleWithUserName, a, b);
    }
}
exports.EventRoleWithUserName = EventRoleWithUserName;
EventRoleWithUserName.runtime = protobuf_1.proto3;
EventRoleWithUserName.typeName = "spwn.event.v1.EventRoleWithUserName";
EventRoleWithUserName.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_role", kind: "message", T: EventRole },
    { no: 2, name: "user_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=admin_common_pb.js.map